import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(legacy)/error.tsx");
